import React from 'react'
import ButtonSimple from '~/Common-Objects/UI/Forms/ButtonSimple/ButtonSimple'
import Column from '~/Common-Objects/Grids/Column/Column'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import OptionsDropdown from '~/Common-Objects/UI/OptionsDropdown/OptionsDropdown'
import PagingBlock from '~/Common-Objects/Tables/DataTablePaging/DataTablePaging'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import axios from '~/data/http/axios'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'
import NumberFunctions from '~/Classes/numberFormatFunctions'
import EditNotification from './editNotification'
import EditEvents from './editEvents'
import { connect } from 'react-redux'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import i18n from '~/i18n'
import { justifyContent } from '~/Classes/dragAndDropDefaults'
//CONNECT TO STORE
@connect((store) => {
    return {
        user: store.user,
        permissionStore: store.permission,
        siteMaster: store.siteMaster,
        accountMaster: store.accountMaster
    }
})
export default class SiteTrackerPaths extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingPaths: true,
            paths: [],
            showIgnored: false,
            pageSize: 30,
            searchText: '',
            page: 0,
            orderBy: 'hits',
            orderDir: 'desc',
            total: 0
        }
        this.getPaths = this.getPaths.bind(this)
        this.tableUpdater = this.tableUpdater.bind(this)
        this.editNotification = this.editNotification.bind(this)
        this.updatePath = this.updatePath.bind(this)
        this.addEvent = this.addEvent.bind(this)
        this.deleteEvent = this.deleteEvent.bind(this)
        this.updatePathIgnore = this.updatePathIgnore.bind(this)
        this.changeSearchText = this.changeSearchText.bind(this)
        this.searchTimer
    }

    componentDidMount() {
        this.getPaths()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.startDate != this.props.startDate || prevProps.endDate != this.props.endDate) {
            this.getPaths()
        }
    }

    addEvent(path) {
        var drawerContent = (
            <EditEvents
                path={path}
                tracker={this.props.tracker}
                close={() => {
                    this.props.dispatch(siteMaster.alterSiteDrawer(false, false, 'right', null, true))
                    this.getPaths()
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '400px'))
    }

    updatePathIgnore(path) {
        axios
            .put('/accountMaster/tracker/' + this.props.tracker.id + '/path/' + path.id, { ignore: !path.ignore })
            .then(() => {
                this.getPaths()
            })
            .catch()
    }

    getPaths() {
        let qs =
            '?startDate=' +
            this.props.startDate.format('YYYY-MM-DD') +
            '&endDate=' +
            this.props.endDate.format('YYYY-MM-DD') +
            '&limit=' +
            this.state.pageSize +
            '&offset=' +
            this.state.page * this.state.pageSize

        if (this.state.orderBy) {
            qs += '&orderBy=' + this.state.orderBy
        }
        if (this.state.orderDir) {
            qs += '&orderDir=' + this.state.orderDir
        }
        if (this.state.showIgnored) {
            qs += '&showIgnored=true'
        }
        if (this.state.searchText.length > 2) {
            qs += '&searchText=' + this.state.searchText
        }

        axios.get('/accountMaster/tracker/' + this.props.tracker.id + '/path' + qs).then((response) => {
            this.setState({
                total: response.data.total,
                loadingPaths: false,
                paths: response.data.TrackerPaths.map((path) => {
                    var thisNotifications = (
                        <Icons
                            icon='cross'
                            onClick={() => {
                                this.editNotification(path)
                            }}
                        />
                    )
                    if (path.sendNotifications) {
                        thisNotifications = (
                            <Icons
                                icon='tick'
                                onClick={() => {
                                    this.editNotification(path)
                                }}
                            />
                        )
                    }

                    let events = []
                    if (path.SiteTrackerEventPaths && path.SiteTrackerEventPaths.length) {
                        path.SiteTrackerEventPaths.forEach((event) => {
                            events.push(
                                <SquareChip
                                    iconRight={
                                        <Icons
                                            onClick={() => {
                                                this.deleteEvent(path, event)
                                            }}
                                            icon='cross'
                                            style={{ width: '15px', height: '15px' }}
                                        />
                                    }
                                    className='mar-r10'
                                >
                                    {event.eventName}
                                </SquareChip>
                            )
                        })
                    }
                    events.push(
                        <ButtonSimple
                            className=''
                            onClick={() => {
                                this.addEvent(path)
                            }}
                        >
                            Add Event
                        </ButtonSimple>
                    )
                    return {
                        path: {
                            headerValue: i18n.t('campaigns:sitetracking.trackingpages.websitePath'),
                            divClasses: 'truncate',
                            orderBy: true,
                            value: (
                                <div>
                                    {path.path}
                                    {path.ignore && <Icons icon='eye-off' />}
                                </div>
                            )
                        },
                        hits: {
                            headerValue: i18n.t('campaigns:sitetracking.trackingpages.hits'),
                            value: (
                                <SquareChip className='square-chip-primary square-chip-large'>
                                    {path.ignore ? '-' : NumberFunctions.formatNumber(path.hits)}
                                </SquareChip>
                            ),
                            width: 80,
                            orderBy: true,
                            align: 'center'
                        },
                        hitsInRange: {
                            headerValue: i18n.t('campaigns:sitetracking.trackingpages.hitsInRange'),
                            value: (
                                <SquareChip className='square-chip-primary square-chip-large'>
                                    {path.ignore ? '-' : NumberFunctions.formatNumber(path.hitsInRange)}
                                </SquareChip>
                            ),
                            width: 80,
                            orderBy: false,
                            align: 'center'
                        },
                        notifications: {
                            headerValue: i18n.t('campaigns:sitetracking.trackingpages.notifications'),
                            value: thisNotifications,
                            align: 'center'
                        },
                        events: {
                            headerValue: 'Events',
                            value: events,
                            align: 'center'
                        },
                        updatedAt: {
                            headerValue: i18n.t('campaigns:sitetracking.trackingpages.lastHit'),
                            value: DateTimeFunctions.formatDateTime(path.updatedAt),
                            width: 250,
                            orderBy: true,
                            align: 'center'
                        },

                        options: {
                            headerValue: '',
                            value: (
                                <OptionsDropdown popWidth='150px'>
                                    <ul>
                                        <li>
                                            <a onClick={() => this.editNotification(path)}>
                                                {i18n.t('campaigns:sitetracking.trackingpages.setupNotifications')}
                                            </a>
                                        </li>
                                        <li>
                                            <a onClick={() => this.updatePathIgnore(path)}>
                                                {path.ignore
                                                    ? i18n.t('campaigns:sitetracking.trackingpages.unignore')
                                                    : i18n.t('campaigns:sitetracking.trackingpages.ignore')}
                                            </a>
                                        </li>
                                    </ul>
                                </OptionsDropdown>
                            ),
                            orderBy: false,
                            fixed: true,
                            width: 20
                        }
                    }
                })
            })
        })
    }

    tableUpdater(currentPage, sortDirection, sortColumn) {
        this.setState({ page: currentPage, orderBy: sortColumn, orderDir: sortDirection }, this.getPaths)
    }

    editNotification(path) {
        var drawerContent = <EditNotification path={path} tracker={this.props.tracker} updatePath={this.updatePath} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '400px'))
    }

    updatePath(path, closeDrawer) {
        var self = this
        if (closeDrawer) {
            this.props.dispatch(siteMaster.alterSiteDrawer(false, false, 'right', null, true))
        }
        axios
            .put('/accountMaster/tracker/' + this.props.tracker.id + '/path/' + path.id, path)
            .then(() => {
                self.getPaths()
            })
            .catch()
    }

    changeSearchText(e) {
        this.setState({ searchText: e.target.value, page: 0 }, () => {
            clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(() => {
                this.getPaths()
            }, 350)
        })
    }

    async deleteEvent(path, event) {
        await axios.delete(`/accountMaster/tracker/${this.props.tracker.id}/path/${path.id}/event/${event.id}`)
        this.getPaths()
    }
    render() {
        if (this.state.loadingPaths) {
            return <LoadingIcons iconType='2' />
        }
        return (
            <div>
                <Row>
                    <Column xs={12} hide={['xs', 'sm']}>
                        <div className='quickFlex mar-b20' style={{ justifyContent: 'space-between' }}>
                            <TextInput
                                outerStyle={{ minWidth: '250px' }}
                                value={this.state.searchText}
                                onChange={this.changeSearchText}
                                placeholder={i18n.t('campaigns:sitetracking.trackingpages.searchPlaceholder')}
                                className='growOnFocus400'
                                iconLeft={
                                    <Icons
                                        icon='magnifier'
                                        style={{ height: 16, width: 16, marginTop: '1px' }}
                                        color='#2B2F41'
                                    />
                                }
                            />
                            <div className='quickFlex' style={{ justifyContent: 'flex-end', gap: 10 }}>
                                <Select
                                    value={this.state.showIgnored}
                                    onChange={(e) => this.setState({ showIgnored: e.target.value }, this.getPaths)}
                                    data={[
                                        {
                                            value: false,
                                            label: i18n.t('campaigns:sitetracking.trackingpages.notIgnored')
                                        },
                                        { value: true, label: i18n.t('campaigns:sitetracking.trackingpages.ignored') }
                                    ]}
                                    inlineLabel={i18n.t('campaigns:sitetracking.trackingpages.showIgnored')}
                                />
                                <Select
                                    align='right'
                                    outerClassName='mar-r5'
                                    inlineLabel='Per Page'
                                    value={this.state.pageSize}
                                    data={[10, 30, 50, 100]}
                                    onChange={(e) => this.setState({ pageSize: e.target.value }, this.getPaths)}
                                />
                            </div>
                        </div>
                    </Column>
                    <Column xs={12} md={12}>
                        <Paper isLoading={this.state.loadingPaths} className='full-height-not-mob'>
                            <DataTable1
                                noResultsTxt={i18n.t('campaigns:sitetracking.trackingpages.noDataFound')}
                                tableData={this.state.paths}
                                dataUpdater={this.tableUpdater}
                                loadingData={false}
                                width='100%'
                                pageSize='100'
                                hasCheckBoxes='no'
                                sortedColumn={this.state.orderBy}
                                sortedDirection={this.state.orderDir}
                            />
                            <Row>
                                <Column xs={12} hide={['xs', 'sm']} className='center-xs mar-t20'>
                                    <PagingBlock
                                        totalRows={this.state.total}
                                        pageSize={this.state.pageSize}
                                        numberOfLinks='10'
                                        currentPage={this.state.page}
                                        changePage={this.tableUpdater}
                                        text={i18n.t('page') + ':'}
                                    />
                                </Column>
                            </Row>
                        </Paper>
                    </Column>
                </Row>
            </div>
        )
    }
}
